$(document).on('change', '#medicine_unit', function () {
  var x = document.getElementById("medicine_unit_gram_form");
  if (this.value === "dose") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
});
